export default __webpack_public_path__ + "static/media/tarjetas.1b4e5454.svg";